import {
  actualData,
  dates,
  forecastData,
  goalData,
  labels,
} from "../../constants";

const performanceData = {
  labels,
  actualData,
  dates,
  forecastData,
  goalData,
};

export { performanceData };
